import "./VerticalSplashImage.css";

export default function VerticalSplashImage({ children }) {
    return (
        <div className="vertical-splash-container">
            <div className="splash-content">
                {children}
            </div>
        </div>
    );
}
